import React from 'react';

const NegativeIcon = ({
    width = 100,
    height = 100,
    fill = '#FF224D'
}: {
    width?: number;
    height?: number;
    fill?: string;
}) => (
    <svg width={width} height={height} viewBox="0 0 100 100" className="icon icon-negative">
        <path
            fill={fill}
            fillRule="nonzero"
            d="M50 0c27.614 0 50 22.386 50 50s-22.386 50-50 50S0 77.614 0 50 22.386 0 50 0zm0 5C25.147 5 5 25.147 5 50s20.147 45 45 45 45-20.147 45-45S74.853 5 50 5zM31.137 27.61l.13.122L50 46.465l18.732-18.733a2.5 2.5 0 0 1 3.658 3.405l-.122.13L53.535 50l18.733 18.732a2.5 2.5 0 0 1-3.405 3.658l-.13-.122L50 53.535 31.268 72.268a2.5 2.5 0 0 1-3.658-3.405l.122-.13L46.465 50 27.732 31.268a2.5 2.5 0 0 1 3.405-3.658z"
        />
    </svg>
);

export default NegativeIcon;
